// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_name__AGxMs:hover {
  text-decoration: underline;
}

.styles_name__AGxMs {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/3D/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF;;AACA;EACE,eAAA;AAEF","sourcesContent":[".name:hover {\n  text-decoration: underline;\n}\n.name {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": `styles_name__AGxMs`
};
export default ___CSS_LOADER_EXPORT___;
